/*
 * @Author: Phoenix
 * @Date: 2020-02-05 15:23:36
 * @LastEditTime: 2021-01-13 09:32:13
 * @Description: http request global error code
 * @FilePath: /ups-single-window-web/src/request/error-code.js
 * @未经本人许可，任何单位及个人不得以任何方式对本产品进行使用、复制、修改、抄录、传播或与其它产品捆绑使用、销售。
 */
var ErrorCode = {
  ErrRequestSuccess: 200,
  ErrRequestError: 400,
  ErrRequestNeedRelogin: 401,
  ErrRequestForbidden: 403,
  ErrRequestNotFound: 404,
  ErrRequestMethodNotAllowed: 405,
  ErrRequestTimeOut: 408,
  ErrRequestConflict: 409,
  ErrRequestGone: 410,
  ErrRequestMediaTypeUnsupported: 415,
  ErrRequestLocked: 423,
  ErrRequestInternalServerError: 500,
  ErrRequestLoginFail: 10000,
  ErrRequestFrequentOperation: 207,
  ErrRequestUnknownError: 99999,
  ErrRequestNewUser: 10002,
  ErrRequestNeedUpdatePassword: 10003,
  ErrRequestAccountTransfer: 10004,
  ErrRequestPwdNotMatch: 10005,
  ErrRequestAccountLocked: 10006,
  ErrRequestException: 20000 // 清关列表查看接口报20000
};
export default ErrorCode;